import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'
import { integrationsKeys } from 'utils/query-keys'
import useConstructUrl from './use-construct-url'
import { Integration } from 'interfaces/integration'

interface Props {
  isCustom?: boolean
  query?: string
}

const useIntegrations = ({ query, isCustom }: Props = {}) => {
  const { constructUrl } = useConstructUrl()
  const apiParams = {
    ...((isCustom === false || isCustom === true) && { is_custom: isCustom }),
    ...(query && { q: query }),
  }

  return useQuery([...integrationsKeys.indexes, apiParams], () => {
    const url = constructUrl(`${BASE_API_URL}/admin/api/v2/integrations`, {
      ...apiParams,
    })
    return fetchIntegrations(url)
  })
}

interface IntegrationData {
  page: number
  number_of_pages: number
  data: {
    integrations: Integration[] //
  }
}

const fetchIntegrations = async (url: string) => {
  let response = await fetch(url, {
    method: API_METHODS.GET,
    headers: apiHeaders(store.getState()),
  })
  response = handleErrors(response)
  const json: IntegrationData = await response.json()
  return json
}

export default useIntegrations
